module.exports = __webpack_public_path__ + "img/back-icon02.361de343.png";